// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ZYTu9","label":"styles_label____ww2","icon":"styles_icon__FS7W3"};